import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4595b448"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "spin", "rtl"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx._width,
    height: _ctx._height,
    spin: _ctx.spin,
    rtl: _ctx.rtl,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    ref: "host"
  }, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        "data-follow-stroke": "currentColor",
        d: "M7.667 14.333a6.65 6.65 0 0 0 4.714-1.952 6.646 6.646 0 0 0 1.952-4.714 6.646 6.646 0 0 0-1.952-4.714A6.646 6.646 0 0 0 7.667 1a6.643 6.643 0 0 0-4.714 1.953A6.646 6.646 0 0 0 1 7.667c0 1.84.746 3.507 1.953 4.714a6.646 6.646 0 0 0 4.714 1.952Z",
        "stroke-width": "1.6",
        "stroke-linejoin": "round",
        stroke: _ctx._stroke
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        "data-follow-stroke": "currentColor",
        d: "M8 9V4.5",
        "stroke-width": "1.6",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        stroke: _ctx._stroke
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        "data-follow-fill": "currentColor",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 12.042a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z",
        fill: _ctx._fill
      }, null, 8, _hoisted_4)
    ])
  ], 8, _hoisted_1))
}